import {makeApiCall} from "../Api/makeApiCall";

export const EDP_AIRFLOW_URL = `${process.env.REACT_APP_EDP_API_BASE_URL}/airflow/info/`

export function getEdpAirflowInfo() {
    return makeApiCall(EDP_AIRFLOW_URL)
}

export function getEdpAirflowUri() {
    return getEdpAirflowInfo().then(r => {
        return r.uri
    })
}
